// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y_6d","content":"styles_content__KgTsJ"};